import { QueryParameters as HubLayoutQueryParameters } from "@faire/web-api/api/v2/layout/browse/get";
import { useQuery as useHubLayoutQuery } from "@faire/web-api/api/v2/layout/browse/get-hooks";

import { useSettingSDUICategoryPageRedesign } from "@faire/retailer/settings/useSettingSDUICategoryPageRedesign";
import { useCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";

export const useBrowseLayoutQuery = () => {
  const navigationPath = useCurrentNavigationPath();
  const shouldUseV3LayoutApis = useSettingSDUICategoryPageRedesign();

  return useHubLayoutQuery(
    HubLayoutQueryParameters.build({
      navigation_path: navigationPath,
    }),
    {
      staleTime: Infinity,
      enabled: !shouldUseV3LayoutApis,
    }
  );
};
